module.exports = __webpack_public_path__ + "static/media/media-close.47d4ea20.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/icons/media-close.svg
// module id = 810
// module chunks = 0